import {
  Card,
  Stack,
  Heading,
  IconTick,
  Text,
  List,
} from 'braid-design-system';
import React from 'react';

import {
  desktopFeatureLabels,
  type DesktopFeatures,
  sortDesktopFeatures,
} from 'src/data/listing-products/desktop';
import {
  desktopFeatureLabelsFreemium,
  type DesktopFeaturesFreemium,
} from 'src/data/listing-products/freemium/desktop';
import {
  isFreemiumExperiment,
  isStandard,
} from 'src/data/listing-products/products';
import {
  getProductInfo,
  type ListingProductWithPackageInfo,
} from 'src/data/listing-products/shared';
import { ListingProductCode } from 'src/generated/graphql';

interface ProductDetailsProps {
  product: ListingProductWithPackageInfo;
}

const ProductDetails = ({ product }: ProductDetailsProps) => {
  const productInfo = getProductInfo(product);

  const featureLabels = sortDesktopFeatures(productInfo.features.desktop)
    .filter(([_, featureConfig]) => featureConfig === 'enabled')
    .map(([feature]) => desktopFeatureLabels[feature as keyof DesktopFeatures]);

  const featureLabelsFreemium = sortDesktopFeatures(
    productInfo.features.desktop,
  )
    .filter(([_, featureConfig]) => featureConfig === 'enabled')
    .map(
      ([feature]) =>
        desktopFeatureLabelsFreemium[feature as keyof DesktopFeaturesFreemium],
    );

  return (
    <Card data={{ testid: 'generic-product-details' }}>
      <Stack space="large" align="left">
        <Heading level="3">
          Purchase{' '}
          {isStandard(product.productCode) ? 'Standard' : product.description}
        </Heading>
        <List
          size="large"
          space="large"
          type="icon"
          icon={<IconTick tone="positive" />}
        >
          {(isFreemiumExperiment ? featureLabelsFreemium : featureLabels).map(
            (label, key) => (
              <Text key={key}>{label}</Text>
            ),
          )}
        </List>
        {product.productCode !== ListingProductCode.Freemium && (
          <Text size="large" data={{ testid: 'generic-product-details-price' }}>
            ${product.cost / 100} + GST
          </Text>
        )}
      </Stack>
    </Card>
  );
};

export default ProductDetails;
